import { cn } from '../lib/utils.js';

/**
 * @param {{
 *   title: import('react').ReactNode,
 *   description?: import('react').ReactNode,
 *   actions?: import('react').ReactNode,
 *   breadcrumb?: import('react').ReactNode,
 *   className?: string,
 * }} props
 */
export function PageHeader({ title, description, actions, breadcrumb, className }) {
  return (
    <div data-slot="page-header" className={cn('flex flex-col gap-3 pb-4 sm:flex-row sm:items-end sm:justify-between', className)}>
      <div className="flex min-w-0 flex-col gap-1">
        {breadcrumb && (
          <nav aria-label="Brotkrumen" className="text-xs text-muted-foreground">
            {breadcrumb}
          </nav>
        )}
        <h1 className="truncate text-h1 font-semibold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
